export default __webpack_public_path__ + "static/media/ID20944999@2x.54143458.png";